/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Section_DeliveryInputs */

const vi_cdo_section_delivery = /** @type {(inputs: Cdo_Section_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng`)
};

/**

* @param {Cdo_Section_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_section_delivery = /** @type {((inputs?: Cdo_Section_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Section_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_section_delivery(inputs)
});